import Moment from 'moment'
import MomentTimeZone from 'moment-timezone'

window.moment = Moment
MomentTimeZone()

export default ({ $axios, redirect, store, $dialog, app }) => {
  const i18n = store.$i18n
  let isRefreshing = false
  const timezone = window.moment.tz.guess()
  $axios.setHeader('X-Time-Zone', timezone)
  $axios.setHeader('X-Console-Language', app.i18n.localeProperties.code)
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    $axios.setHeader('X-Console-Language', newLocale)
  }

  $axios.onRequest((config) => {
    if (!isRefreshing) {
      config.headers.Authorization = localStorage.getItem('Token') || ''
    }
  })

  $axios.onResponseError(async (error) => {
    const code = parseInt(error.response && error.response.status)

    if (!code) {
      $dialog.message.error('Oops, something went wrong.')
    }

    switch (code) {
      case 401:
        if (!isRefreshing) {
          isRefreshing = true
          const originalRequest = { isError: false, response: undefined }
          await $axios
            .$post(
              '/generate-token/',
              {},
              {
                headers: {
                  Authorization: localStorage.getItem('RefreshToken'),
                },
              }
            )
            .then(async (resp) => {
              localStorage.setItem('Token', resp.Result.Token)
              localStorage.setItem('RefreshToken', resp.Result.RefreshToken)
              localStorage.setItem(
                'privileges',
                JSON.stringify(resp.Result.UserData.Privileges)
              )
              error.config.headers.Authorization = resp.Result.Token
              isRefreshing = false
              await $axios
                .request(error.config)
                .then((resp) => {
                  originalRequest.response = resp
                })
                .catch((err) => {
                  if (err.response.status !== 401) {
                    originalRequest.isError = true
                    originalRequest.response = err
                  }
                })
            })
            .catch(() => {
              isRefreshing = false
            })
          if (originalRequest.response) {
            return originalRequest.isError
              ? Promise.reject(originalRequest.response)
              : Promise.resolve(originalRequest.response)
          }
        }
        app.$user.clearLocalStorage()

        /*
         * https://github.com/nuxt/nuxt.js/issues/4491
         * (when invalid token and refreshToken; during refresh page or nuxt links)
         * also returned directly  "return redirect('/login/')" it was causing an error
         */
        if (process.client) {
          document.location = '/login/'
        } else {
          redirect('/login/')
        }
        throw error
      case 403:
        $dialog.message.error(i18n.t('access_denied.accessNotPermittedMsg'))
        throw error
      case 404:
        $dialog.message.error(i18n.t('validation_new.destinationNotFound'))
        throw error
      case 500:
        $dialog.message.error(
          i18n.t('validation_new.somethingHappenedOnOurServers')
        )
        throw error
      default:
        throw error
    }
  })
}
